<div class="dialog-header flex align-items-center">
	<div class="left">
		<h1 mat-dialog-title>
			{{ data.listing.name | getLocale:data.listing?.locale?.name }}
		</h1>
		<p i18n="Choose a Sub-Channel@@creativeUnitPackageListingChildrenDialogTitle">
			{{ (data.listing.childrenDialogTitle || 'Select a Sub-Template') | getLocale:data.listing?.locale?.childrenDialogTitle }}
		</p>
	</div>

	<div class="right">
		<mat-icon [mat-dialog-close]="null" class="cursor-pointer">close</mat-icon>
	</div>
</div>

<div mat-dialog-content class="mt-1">
	<div *ngFor="let child of data.listing?.children" class="card" (click)="onSelect(child)">
		<mat-icon>account_tree</mat-icon>
		<span class="name ml-3">
			{{ child.name | getLocale:child.locale?.name }}
		</span>
	</div>
</div>
